import script from "./RbRichTextEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./RbRichTextEditor.vue?vue&type=script&setup=true&lang=js"

import "./RbRichTextEditor.vue?vue&type=style&index=0&id=508f9818&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-508f9818"]])

export default __exports__